var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import TinyDatePicker from 'tiny-date-picker';
import './DatePicker.css';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from 'Theme';
import { lang } from 'helpers/i18n';
import { Input } from 'elements';
import { filterHours } from '../helpers/Utils';
class DatePicker extends Component {
    constructor(props) {
        super(props);
        this.id = `datepicker-${this.props.name}`;
        this.handleHourChange = (event) => {
            this.setState({ hour: Number(event.target.value) });
        };
        this.handleMinutesChange = (event) => {
            this.setState({ minutes: Number(event.target.value) });
        };
        this.handleClick = (event) => {
            console.log('event.keyCode', event.charCode);
            if (this.props.onKeyPress)
                this.props.onKeyPress(event.charCode);
        };
        this.handleChange = (state) => {
            const { date, hour, minutes } = state;
            date.setHours(hour);
            date.setMinutes(minutes);
            this.props.onChange(this.props.name, date);
        };
        this.ceros = (value) => {
            if (value > 9) {
                return String(value);
            }
            return '0'.concat(String(value));
        };
        const date = props.date && typeof props.date === 'string'
            ? new Date(props.date)
            : props.date || new Date();
        this.state = {
            date,
            hour: date.getHours(),
            minutes: date.getMinutes()
        };
        // console.log(this.id)
    }
    componentDidMount() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        // today.setDate(today.getDate()-1)
        this.picker = TinyDatePicker(document.getElementById(this.id), {
            dateClass: dt => {
                if (!this.props.calendarAvailable) {
                    return '';
                }
                const day = dt;
                if (day < today) {
                    return '';
                }
                const { disabledDays } = this.props;
                let clase = 'enabled';
                if (disabledDays) {
                    const disabledDay = disabledDays.find(value => value.day === day.getDate() && value.month === day.getMonth() && value.year === day.getFullYear());
                    if (this.props.stretch && disabledDay && disabledDay.hours && disabledDay.hours.length > 0) {
                        const hoursFiltered = filterHours(this.props.stretch.horasIda, disabledDay.hours);
                        clase = (hoursFiltered.length === this.props.stretch.horasIda.length) ? 'disabled' : 'partial';
                    }
                }
                return clase;
            },
            mode: 'dp-permanent',
            hilightedDate: this.state.date,
            /*min: today,*/
            max: this.props.maxDate ? new Date() : undefined,
            lang: lang === 'es'
                ? {
                    days: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
                    months: [
                        'Enero',
                        'Febrero',
                        'Marzo',
                        'Abril',
                        'Mayo',
                        'Junio',
                        'Julio',
                        'Agosto',
                        'Septiembre',
                        'Octubre',
                        'Noviembre',
                        'Deciembre'
                    ],
                    today: 'Hoy',
                }
                : {
                    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    months: [
                        'January',
                        'February',
                        'March',
                        'April',
                        'May',
                        'June',
                        'July',
                        'August',
                        'September',
                        'October',
                        'November',
                        'December'
                    ],
                    today: 'Today',
                },
            dayOffset: lang === 'es' ? 1 : 0
        });
        this.picker.on('select', (_, dp) => this.setState({ date: dp.state.selectedDate }));
    }
    componentWillUnmount() {
        var _a;
        (_a = this.picker) === null || _a === void 0 ? void 0 : _a.off();
    }
    componentWillUpdate(nextProps, nextState) {
        if (this.state !== nextState)
            this.handleChange(nextState);
    }
    render() {
        const _a = this.props, { date, name, withTime, onChange, onKeyPress, today } = _a, props = __rest(_a, ["date", "name", "withTime", "onChange", "onKeyPress", "today"]);
        const { hour, minutes } = this.state;
        return (React.createElement("div", Object.assign({}, props),
            React.createElement(DatePickerWrapper, { id: this.id }),
            withTime && (React.createElement(TimePicker, null,
                React.createElement(TimeInput, null,
                    React.createElement(Input, { type: "number", label: 'hora', value: String(hour), min: 0, max: 23, onKeyPress: this.handleClick, onChange: this.handleHourChange })),
                React.createElement(TimeInput, null,
                    React.createElement(Input, { type: "number", label: 'minutos', value: String(minutes), min: 0, max: 59, onKeyPress: this.handleClick, onChange: this.handleMinutesChange }))))));
    }
}
export default DatePicker;
const DatePickerWrapper = cxs('div')({
    color: Theme.color.secondary,
    marginTop: Theme.size.space[1],
    ' .dp-cal-header': {
        fontSize: Theme.fontSize.big
    },
    ' .dp-cal .dp-selected, .dp-cal a:hover, .dp-cal a:focus': {
        color: Theme.color.primary
    },
    ' .dp-days a:focus, .dp-days a:hover, .dp-cal .dp-selected, .dp-years, .dp-months': {
        outline: `${Theme.size.hairline} solid ${Theme.color.hairline}`
    },
    ' .dp-col-header': {
        color: Theme.color.placeholder,
        borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`
    },
    ' .dp-cal-footer': {
        borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
        borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
        [mediaQueries.desktop]: {
            borderBottom: 0
        }
    },
    ' .dp-edge-day, .dp-day-disabled': {
        color: Theme.color.hairline
    },
    ' .disabled': {
        backgroundColor: Theme.color.backred,
        color: 'black'
    },
    ' .enabled': {
        backgroundColor: Theme.color.backgreen,
        color: 'black'
    },
    ' .partial': {
        backgroundColor: Theme.color.backorange,
        color: 'black'
    },
    [mediaQueries.desktop]: {
        outline: `${Theme.size.hairline} solid ${Theme.color.hairline}`
    }
});
const TimePicker = cxs('div')({
    padding: Theme.size.space[1],
    textAlign: 'center',
    borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    [mediaQueries.desktop]: {
        border: 0,
        outline: `${Theme.size.hairline} solid ${Theme.color.hairline}`
    }
});
const TimeInput = cxs('div')({
    width: '4em',
    margin: `0 ${Theme.size.space[1]}`,
    display: 'inline-block'
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/DatePicker.tsx
// module id = 371
// module chunks = 0